import { render } from "./ObjectLabel.vue?vue&type=template&id=2b2d4e3c"
import script from "./ObjectLabel.vue?vue&type=script&lang=js"
export * from "./ObjectLabel.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__